
<button mat-button (click)="openDialog()">Open dialog</button>
<app-player-deck-pager></app-player-deck-pager>
